import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AppPageTranslation, EntityData } from '../models/entity-app.model';
import { TranslateService } from '@ngx-translate/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  entityData!: EntityData;

  constructor(
    private meta: Meta,
    private title: Title,
    private translateService: TranslateService,
    private dbService: NgxIndexedDBService
  ) { }

  changeMeta(pageKey: string, pageTitle: string | null = null) {
    const data: any = localStorage.getItem('entityData');
    this.entityData = JSON.parse(data);
    const page = this.entityData?.translations?.filter(
      (translation) => translation.page == pageKey
    )[0];
    this.meta.updateTag({
      name: 'description',
      content: page?.metaDescription ? page?.metaDescription : '',
    });
    this.meta.updateTag({
      name: 'twitter:description',
      content: page?.metaDescription ? page?.metaDescription : '',
    });
    this.meta.updateTag({
      name: 'og:description',
      content: page?.metaDescription ? page?.metaDescription : '',
    });
    this.meta.updateTag({
      name: 'twitter:title',
      content: page?.metaTitle ? page?.metaTitle : '',
    });
    this.meta.updateTag({
      name: 'og:title',
      content: page?.metaTitle ? page?.metaTitle : '',
    });
    if (pageTitle !== null && pageTitle !== '') {
      let page = '';
      if (this.translateService.instant(pageTitle) !== pageTitle) {
        page = this.translateService.instant(pageTitle);
        const title = page + ' - ' + this.entityData.name;
        this.title.setTitle(title);
      } else {
        this.dbService
          .getByKey('translations', this.translateService.currentLang)
          .subscribe((d: any) => {
            page = d[pageTitle];
            const title = page + ' - ' + this.entityData.name;
            this.title.setTitle(title);
          });
      }
    } else {
      this.title.setTitle(this.entityData.name);
    }
  }

  manualSetSEO(data: { metaTitle: string, metaDescription: string }) {
    if (data.metaTitle && data.metaDescription) {
      const title = data.metaTitle ? data.metaTitle : '';
      const metaDescription = data.metaDescription ? data.metaDescription : '';
      const url = location.href;
      this.meta.updateTag({ name: 'description', content: metaDescription });
      this.meta.updateTag({ name: 'twitter:description', content: metaDescription });
      this.meta.updateTag({ name: 'twitter:title', content: title });
      this.meta.updateTag({ name: 'description', content: metaDescription });
      this.meta.updateTag({ property: 'og:description', content: metaDescription });
      this.meta.updateTag({ property: 'og:title', content: title });
      this.meta.updateTag({ property: 'og:url', content: url });
    }
  }
}
